import { Navigation } from './Navigation';

export function withNavigation<T>(Component: React.ComponentType<T>) {
  return function (props: T) {
    console.log(window.location.href);
    const notifications = !window.location.href.includes('article-blocks');
    return (
      <Navigation noti={notifications}>
        <Component {...props} />
      </Navigation>
    );
  };
}
